// extracted by mini-css-extract-plugin
module.exports = {"root":"GamePad_root__Lay6t","row":"GamePad_row__164Sm","block":"GamePad_block__l2_xd","button":"GamePad_button__3kDFo","wait":"GamePad_wait__5DVYu"};